var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.471 3.362a.667.667 0 00-.943 0L4.862 8.03a.667.667 0 000 .943l4.666 4.666a.667.667 0 00.943-.942L6.276 8.5l4.195-4.195a.667.667 0 000-.943z",
    fill: "#222"
  })));
};
export default SvgArrowLeft;